import { Download } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { OutreachItem } from "./OutreachItem";

export type Props = {
  /** Title for the section */
  title?: string;
  /** Subtitle for the section */
  subtitle?: string;
  /** Description for the section */
  description?: string;
  /** Download URL */
  href: string;
  /** Button label */
  label: string;
  /** Optional children content */
  children?: React.ReactNode;
};

/**
 * Displays a download button action with optional additional content.
 */
export function OutreachButtonAction({
  title,
  subtitle,
  description,
  children,
  href,
  label,
}: Props) {
  return (
    <OutreachItem
      title={title}
      subtitle={subtitle}
      description={description}
      innerClassName="flex flex-col items-start gap-4"
    >
      <Button
        as="a"
        href={href}
        target="_blank"
        download
        variant="secondary"
        iconComponent={Download}
      >
        {label}
      </Button>
      {children}
    </OutreachItem>
  );
}

